import React, { useEffect, useRef, useState } from 'react';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import readXlsxFile from 'read-excel-file';

import usePagination from './usePagination';

import { toast } from 'react-toastify';

import {
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  CircularProgress,
  Table,
} from '@mui/material';

import { Pagination } from '@mui/material';

import { useStyles } from './useStyles';
import { getSeuClube } from 'js/library/utils/API/seuClube';
import { GetPartnerUserForms } from 'js/library/utils/API/apiGetPartnerUserForms';
import { ListAllFieldTypes } from 'js/library/utils/API/apiListAllTypes';
import phone from 'phone';
import { GoBackHeader } from './GoBackHeader';
import { HeaderTitle } from './HeaderTitle';
import { RegisterUsersBatch_v2 } from 'js/library/utils/API/apiRegisterUsersBatch';
import ButtonDefault from 'js/components/ButtonDefault/ButtonDefault';

export default function RegisterListUsers({ history }) {
  const [clientList, setClientList] = useState([]);
  const [columnsTable, setColumnsTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [clubeId] = useState(window.location.href.split('/')[7]);
  const [formInfos, setFormInfos] = useState([]);
  const [fieldTypes, setFieldTypes] = useState([]);
  const [seuClubeInfos, setSeuClubeInfos] = useState({});
  const [page, setPage] = useState(1);

  const fileUploader = useRef(null);

  const PER_PAGE = 10;

  const count = Math.ceil(clientList.length / PER_PAGE);
  const _DATA = usePagination(clientList, PER_PAGE);

  const handleChangePage = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const classes = useStyles();

  useEffect(() => {
    if (clubeId) {
      getSeuClube(clubeId)
        .then((response) => {
          setSeuClubeInfos(response);
          GetPartnerUserForms(response.partnerId).then((result) => {
            setFormInfos(result);
            setLoading(false);

            const generateAddressFields = (index) => [
              {
                fieldName: `streetAve${index}`,
                label: `Logradouro ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'streetAve',
                origin: 'streetAve',
              },
              {
                fieldName: `number${index}`,
                label: `Número ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'number',
              },
              {
                fieldName: `extra${index}`,
                label: `Complemento ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: false,
                origin: 'extra',
              },
              {
                fieldName: `neighborhood${index}`,
                label: `Bairro ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'neighborhood',
              },
              {
                fieldName: `city${index}`,
                label: `Cidade ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'city',
              },
              {
                fieldName: `state${index}`,
                label: `Estado ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'state',
              },
              {
                fieldName: `zipCode${index}`,
                label: `CEP ${index}`,
                fieldType: 'address',
                type: 'addressList',
                required: true,
                origin: 'zipCode',
              },
            ];

            // Contar quantos campos 'addressList' existem
            const addressListFields = result.formFields.filter(
              (field) => field.type === 'addressList'
            );
            const addressCount = addressListFields.length;

            // Geração de campos, agora com sufixos baseados na quantidade de addressList
            let addressIndex = 1;
            const updatedFormFields = result.formFields.reduce((acc, field) => {
              if (field.type === 'addressList') {
                // Sempre gera, mas com sufixo se houver mais de 1 addressList
                const addressFields = generateAddressFields(addressCount > 1 ? addressIndex : '');
                acc.push(...addressFields); // Adiciona os campos ao array
                if (addressCount > 1) {
                  addressIndex++; // Incrementa o índice apenas se houver mais de um 'addressList'
                }
              } else {
                // Adiciona os campos que não são do tipo addressList
                acc.push(field);
              }
              return acc;
            }, []);

            setColumnsTable(updatedFormFields);
          });

          ListAllFieldTypes().then((result) => {
            setFieldTypes(result);
          });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [clubeId]);

  const handleExportExcelFile = () => {
    let removeOptin = columnsTable.filter((field) => field.fieldName !== 'optIn');
    const collumnsNames = removeOptin.map((field) => field.fieldName);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([collumnsNames]);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    const columnWidths = collumnsNames.map((field) => {
      return {
        width: 15,
      };
    });
    worksheet['!cols'] = columnWidths;

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const fileName = 'template.xlsx';

    saveAs(blob, fileName);
  };

  const formatUserList = (formValues) => {
    let userInfoObj = {};
    let contactList = [];
    let documentList = [];
    let addressList = [];

    columnsTable.forEach((field) => {
      const findBlock = fieldTypes.find(({ type }) => type === field.fieldType);
      if (findBlock.block === 'contactList') {
        if (formValues[field.fieldName]) {
          contactList.push({
            type: field.fieldName,
            value: formValues[field.fieldName].value,
          });
        }
      }

      if (findBlock.block === 'documentList') {
        if (formValues[field.fieldName]) {
          documentList.push({
            type: field.fieldName,
            value: formValues[field.fieldName].value,
          });
        }
      }

      if (findBlock.block === 'addressList') {
        if (formValues[field.fieldName]) {
          // Criando um objeto único com todos os campos de endereço
          let addressObject = addressList[0] || {}; // Se já houver um objeto, usamos ele, caso contrário criamos um novo

          // Adicionando o campo atual ao objeto de endereço
          addressObject[field.fieldName] = formValues[field.fieldName].value;

          // Se for o último campo de endereço, adicionamos ao array
          addressList = [addressObject];
        }
      }

      if (findBlock.block === 'root') {
        if (formValues[field.fieldName]?.value) {
          if (field.inputType === 'date') {
            let date = formValues[field.fieldName].value;

            // Verifica se a data está no formato 'dd/mm/yy' ou 'dd/mm/yyyy'
            if (/^\d{2}\/\d{2}\/\d{2}$/.test(date)) {
              // Se for 'dd/mm/yy', considera o ano como '19yy'
              const [day, month, year] = date.split('/');
              date = `19${year}-${month}-${day}`; // Formato 'yyyy-mm-dd'
            } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
              // Se for 'dd/mm/yyyy', apenas troca para 'yyyy-mm-dd'
              const [day, month, year] = date.split('/');
              date = `${year}-${month}-${day}`; // Formato 'yyyy-mm-dd'
            }

            // Usando Date.UTC para garantir que a data seja interpretada como UTC e evitar problemas de fuso horário
            const [year, month, day] = date.split('-');
            const timestamp = new Date(year, month - 1, day).getTime(); // Lembre-se: meses começam do 0 em JavaScript

            if (!isNaN(timestamp)) {
              userInfoObj[field.fieldName] = timestamp;
            }
          } else {
            userInfoObj[field.fieldName] = formValues[field.fieldName].value;
          }
        }
      }
    });

    userInfoObj = {
      ...userInfoObj,
      contactList: [...contactList],
      documentList: [...documentList],
      addressList: addressList,
      partnerId: seuClubeInfos.partnerId,
      partnerName: seuClubeInfos.clubeId,
    };

    const data = {
      partnerInfo: userInfoObj,
      clubeId: seuClubeInfos.clubeId,
      token: formValues[formInfos.tokenType].value,
      cellphone: formValues.cellPhone.value,
    };

    if (seuClubeInfos.name && seuClubeInfos.name.length !== 0) {
      data.name = seuClubeInfos.name;
    }

    return data;
  };

  const validateField = (fieldName, value) => {
    let getField;
    let fieldType;
    try {
      getField = columnsTable.find((field) => field.fieldName === fieldName);
      fieldType = fieldTypes.find(({ type }) => type === getField.fieldType);
    } catch (error) {
      return {
        value: '',
        valid: false,
      };
    }

    if (fieldType && fieldType.type === 'cellPhone') {
      const phoneValidation = phone(value.toString());
      if (phoneValidation.isValid) {
        return {
          value,
          valid: true,
        };
      } else {
        return {
          value,
          valid: false,
        };
      }
    }

    if (fieldType && fieldType.type === 'cpf') {
      const cpf = value.toString().replace(/[^\d]/g, '');
      if (cpf.length === 11) {
        return {
          value: cpf,
          valid: true,
        };
      } else {
        return {
          value: cpf,
          valid: false,
        };
      }
    }

    if (fieldType && fieldType.type === 'date') {
      let date = value.toString().trim();

      // Verifica se a data está no formato 'ddMMyy' ou 'ddMMyyyy'
      if (/^\d{6}$/.test(date)) {
        // Se for 'ddMMyy', o ano deve ser tratado como '19yy'
        date =
          date.slice(0, 2) +
          '/' +
          date.slice(2, 4) +
          (date.length === 6 ? '/19' : '/') +
          date.slice(4);
      } else if (/^\d{8}$/.test(date)) {
        // Se for 'ddMMyyyy', apenas formata
        date = date.slice(0, 2) + '/' + date.slice(2, 4) + '/' + date.slice(4);
      }

      const parsedDate = new Date(date);
      if (isNaN(parsedDate)) {
        return { value, valid: false }; // Retorna inválido se não for uma data válida
      }

      parsedDate.setDate(parsedDate.getDate() + 1);

      // Formatação no padrão dd/mm/yy ou dd/mm/yyyy
      const day = String(parsedDate.getDate()).padStart(2, '0');
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const year = String(parsedDate.getFullYear()).slice(-2); // Pega os dois últimos dígitos do ano

      const formattedDate = `${day}/${month}/${year}`;
      return { value: formattedDate, valid: true };
    }

    if (fieldType && fieldType.type === 'address') {
      switch (fieldName) {
        case 'streetAve':
        case 'neighborhood':
        case 'city':
          return { value, valid: value && value.length > 0 };
        case 'state':
          return { value, valid: value && value.length === 2 };
        case 'number':
          return {
            value,
            valid:
              value && (typeof value === 'string' ? value.length > 0 : !isNaN(value) && value > 0),
          };

        case 'zipCode':
          if (value && /^[0-9]{5}[0-9]{3}$/.test(value)) {
            return { value, valid: true };
          }
          return { value, valid: false };

        default:
          return { value, valid: true };
      }
    }

    return {
      value,
      valid: true,
    };
  };

  function validateAddressGroup(obj) {
    // Atualize os nomes dos campos conforme seu arquivo XLSX
    const addressFields = ['streetAve', 'number', 'neighborhood', 'city', 'state', 'zipCode'];

    // Verifica se algum dos campos de endereço está preenchido
    const fieldFill = addressFields.some((field) => {
      const fieldValue = obj[field]?.value;
      return fieldValue && fieldValue.toString().trim() !== '';
    });

    // Se algum campo estiver preenchido, todos os campos de endereço não podem ficar vazios
    if (fieldFill) {
      addressFields.forEach((field) => {
        const fieldValue = obj[field]?.value;
        if (!fieldValue || fieldValue.toString().trim() === '') {
          if (obj[field]) {
            obj[field].valid = false;
          } else {
            obj[field] = { value: '', valid: false };
          }
        }
      });
    }
    return obj;
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    const fileExt = file.name.split('.').pop();

    if (fileExt === 'xlsx') {
      setClientList([]);
      const fileXlsx = await readXlsxFile(file);

      const columns = fileXlsx[0];
      const data = fileXlsx.slice(1);

      const formattedData = data.map((row) => {
        const obj = {};
        columns.forEach((column, columnIndex) => {
          obj[column] = row[columnIndex]
            ? validateField(column, row[columnIndex])
            : { value: '', valid: true };
        });
        return validateAddressGroup(obj);
      });

      setClientList(formattedData);
    } else {
      toast.error('Arquivo não é no formato .xlsx');
    }
  };

  const removeEmptyFields = (obj) => {
    if (Array.isArray(obj)) {
      return obj
        .map(removeEmptyFields)
        .filter(
          (item) => item !== null && (typeof item !== 'object' || Object.keys(item).length > 0)
        );
    }

    if (typeof obj === 'object' && obj !== null) {
      const cleaned = {};
      Object.entries(obj).forEach(([key, value]) => {
        const cleanedValue = removeEmptyFields(value);
        const isEmpty =
          cleanedValue === null ||
          cleanedValue === '' ||
          (typeof cleanedValue === 'object' && Object.keys(cleanedValue).length === 0);

        if (!isEmpty) {
          cleaned[key] = cleanedValue;
        }
      });
      return cleaned;
    }

    return obj;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingRegister(true);

    try {
      const filteredUserInfo = clientList.filter((row) => !!row[formInfos.tokenType]);

      const verifyingFieldsInvalids = clientList.filter((row) => {
        return Object.values(row).some((field) => field.valid === false);
      });

      if (verifyingFieldsInvalids.length > 0) {
        throw new Error(
          `Dados do usuário: ${verifyingFieldsInvalids[0].aliasName.value} estão inválidos`
        );
      }

      if (filteredUserInfo.length === 0) {
        throw new Error(
          `O ${
            formInfos.tokenType === 'cellPhone' ? 'número de celular' : formInfos.tokenType
          } é obrigatório`
        );
      }

      const formattedUsers = filteredUserInfo.map((client) =>
        removeEmptyFields(formatUserList(client))
      );

      const response = await RegisterUsersBatch_v2(formattedUsers);
      if (response.status === 200) {
        toast.success(
          'Usuários cadastrados com sucesso! Em breve você poderá consultá-los na aba "Ver membros".'
        );
        setClientList([]);
      } else {
        throw new Error('Erro ao cadastrar usuários.');
      }
    } catch (error) {
      toast.error(error.message || 'Ops, usuários não foram cadastrados.');
    } finally {
      setLoadingRegister(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          height: '50vh',
          width: '100%',
        }}
      >
        <CircularProgress size="6rem" />
      </div>
    );
  }
  return (
    <div style={{ padding: '4rem 32px' }}>
      <GoBackHeader />
      <Container maxWidth={false} className={classes.root}>
        <HeaderTitle pageInfo="Cadastrar em lote" />
        <Grid item xs={12} className={classes.boxInportFiles}>
          <Card>
            <CardContent>
              <Typography variant="subtitle1" style={{ marginTop: 20 }}>
                Carregue um arquivo no formato Excel com o seguinte padrão:
                <br />
                <ButtonDefault
                  variant="contained"
                  size="medium"
                  color="secondary"
                  onClick={handleExportExcelFile}
                  text="Exportar template"
                  sx={{
                    marginTop: '10px',
                  }}
                />
              </Typography>
              <br />
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginTop: '22px' }}>
                <div>
                  {formInfos.tokenType === 'cellPhone'
                    ? 'OBS 1: O dado "cellphone" é obrigatório para realizar o cadastro do cliente. caso não tenha, aparecerá em vermelho na lista abaixo.'
                    : `OBS 1: Os dados "Nome e ${formInfos.tokenType}" são obrigatórios para realizar o cadastro do cliente. Caso não tenha, aparecerá em vermelho na lista abaixo.`}
                </div>
                <div>
                  OBS 2: O número de telefone tem que ter o seguinte formato: (DDD) + telefone -
                  exemplo: +5511970697706, caso contrário o mesmo não será cadastrado.
                </div>
              </Typography>
              <br />
              <div>
                <ButtonDefault
                  variant="contained"
                  size="medium"
                  color="secondary"
                  onClick={() => fileUploader.current.click()}
                  text="Carregar arquivo"
                />
                <input
                  type="file"
                  accept=".xlsx"
                  ref={fileUploader}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  onClick={(e) => {
                    // Permite selecionar o mesmo arquivo novamente
                    e.target.value = null;
                  }}
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} className={classes.boxListUsers}>
          {clientList.length > 0 && (
            <>
              <strong>Usuários Listados: </strong>
              <TableContainer className={classes.table}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columnsTable.map((column, index) => (
                        <TableCell align="left" key={index}>
                          <strong>{column.fieldName}</strong>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {_DATA.currentData().map((client, index) => (
                      <TableRow key={'row' + index}>
                        {columnsTable.map((item, indexColumns) => (
                          <React.Fragment key={indexColumns}>
                            <TableCell
                              style={{
                                backgroundColor: `${
                                  client[item.fieldName] && !client[item.fieldName].valid
                                    ? 'red'
                                    : '#ffff'
                                }`,
                              }}
                              align="left"
                            >
                              {client[item.fieldName] && client[item.fieldName].value}
                            </TableCell>
                          </React.Fragment>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Pagination
                sx={{ mt: 3 }}
                count={count}
                size="large"
                page={page}
                variant="outlined"
                shape="rounded"
                onChange={handleChangePage}
              />

              <div align="center" style={{ marginTop: 15 }}>
                <ButtonDefault
                  variant="contained"
                  size="medium"
                  color="primary"
                  disabled={clubeId === '' || loadingRegister}
                  loading={loadingRegister}
                  onClick={(event) => handleSubmit(event)}
                  text="Cadastrar todos"
                  loadingText="Cadastrando..."
                  sx={{
                    color: loadingRegister ? '#383838' : '#fff',
                    marginBottom: '2rem',
                    background: loadingRegister && '#dbdbdb',
                  }}
                />
              </div>
            </>
          )}
        </Grid>
      </Container>
    </div>
  );
}
